import * as React from 'react';
import { theme } from '../../../theme';

interface Props {
  color?: string;
}

export const WarningIcon: React.FC<Props> = ({ color = theme.colors.text }) => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.54773 6.6353C5.15685 3.78801 5.9614 2.36435 7.06545 1.99788C7.67279 1.79628 8.32705 1.79628 8.93439 1.99788C10.0385 2.36435 10.843 3.78801 12.4521 6.6353C14.0613 9.48256 14.8658 10.9062 14.6245 12.0662C14.4917 12.7044 14.1645 13.2832 13.6899 13.7198C12.8273 14.5134 11.2182 14.5134 7.99992 14.5134C4.78169 14.5134 3.17257 14.5134 2.30989 13.7198C1.83531 13.2832 1.50818 12.7044 1.3754 12.0662C1.13405 10.9062 1.93861 9.48256 3.54773 6.6353Z"
      stroke={color}
      strokeWidth="1.5"
    />
    <path
      d="M7.99463 10.8467H8.00063"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 8.84674V6.18005"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const WarningIconM: React.FC<Props> = ({
  color = theme.colors.text,
}) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.32171 9.68293C7.73539 5.41199 8.94222 3.27651 10.5983 2.72681C11.5093 2.4244 12.4907 2.4244 13.4017 2.72681C15.0578 3.27651 16.2646 5.41199 18.6783 9.68293C21.092 13.9538 22.2988 16.0893 21.9368 17.8293C21.7376 18.7866 21.2469 19.6548 20.535 20.3097C19.241 21.5 16.8274 21.5 12 21.5C7.17265 21.5 4.75897 21.5 3.46496 20.3097C2.75308 19.6548 2.26239 18.7866 2.06322 17.8293C1.70119 16.0893 2.90803 13.9538 5.32171 9.68293Z"
      stroke={color}
      strokeWidth="1.5"
    />
    <path
      d="M11.9922 16H12.0012"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 13V9"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
